import { useState, type ReactNode } from "react";
import { BarChart3, Table2 } from "lucide-react";
import tableStyles from "../ui/Table.module.css";
import styles from "./Chart.module.css";

export interface LegendItem {
  label: string;
  color: string;
}

interface ChartFrameProps {
  legend?: LegendItem[];
  /** The same numbers as a table — the accessible fallback and the "relief" for low-contrast hues. */
  table: { columns: string[]; rows: (string | number)[][] };
  children: ReactNode;
  toolbar?: ReactNode;
}

export function ChartFrame({ legend, table, children, toolbar }: ChartFrameProps) {
  const [view, setView] = useState<"chart" | "table">("chart");
  return (
    <div className={styles.frame}>
      <div className={styles.frameBar}>
        {legend && legend.length > 1 ? (
          <ul className={styles.legend}>
            {legend.map((item) => (
              <li key={item.label}>
                <span className={styles.swatch} style={{ background: item.color }} />
                {item.label}
              </li>
            ))}
          </ul>
        ) : (
          <span />
        )}
        <div className={styles.frameTools}>
          {toolbar}
          <button
            type="button"
            className={styles.viewToggle}
            onClick={() => setView(view === "chart" ? "table" : "chart")}
            aria-label={view === "chart" ? "Tampilkan sebagai tabel" : "Tampilkan sebagai grafik"}
          >
            {view === "chart" ? <Table2 aria-hidden /> : <BarChart3 aria-hidden />}
            {view === "chart" ? "Tabel" : "Grafik"}
          </button>
        </div>
      </div>
      {view === "chart" ? (
        children
      ) : (
        <div className={`${tableStyles.wrap} ${styles.tableView}`}>
          <table className={tableStyles.table}>
            <thead>
              <tr>
                {table.columns.map((column, i) => (
                  <th key={column} className={i > 0 ? tableStyles.right : undefined}>
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {table.rows.map((row, r) => (
                <tr key={r}>
                  {row.map((cell, i) => (
                    <td key={i} className={i > 0 ? tableStyles.right : undefined}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
